import { render, staticRenderFns } from "./ApprovalReasonRemarkView.vue?vue&type=template&id=0bbd5bd7&scoped=true"
import script from "./ApprovalReasonRemarkView.vue?vue&type=script&lang=js"
export * from "./ApprovalReasonRemarkView.vue?vue&type=script&lang=js"
import style0 from "./ApprovalReasonRemarkView.vue?vue&type=style&index=0&id=0bbd5bd7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbd5bd7",
  null
  
)

export default component.exports